<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qUw5Z2/tc-custom/9781466826021.jpg?1726024335748" alt="This image is the cover for the book King Rat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King Rat
      </h1>
      <p class="bookDescription body article font2">
        <b>A young man discovers his identity among a tribe of rats in the renowned fantasy author’s "riveting, brilliant novel"—with an introduction by Tim Maughan (Charles de Lint).</b><br/><br/> Something is stirring in London’s dark, stamping out its territory in brickdust and blood. Something has murdered Saul Garamond’s father, and left Saul to pay for the crime. But a shadow from the urban waste breaks into Saul’s prison cell and leads him to freedom: a shadow called King Rat.<br/><br/> King Rat reveals to Saul his own royal heritage—a heritage that draws him into the grimy, magical world below London’s streets. With drum-and-bass pounding the backstreets, Saul must confront the forces that would use him, the ones that would destroy him, and those that have shaped his own bizarre identity.<br/><br/> World Fantasy Award–winning author China Miéville began his astounding career with the novel <i>King Rat</i>, which combines a young man’s search for identity with a pulse-pounding story of revenge and madness. This Tor Essential edition includes an introduction by Tim Maughan, author of <i>Infinite Detail.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        China Miéville, Tim Maughan
      </h2>
      
      <p class="authorDescription body article">CHINA MIÉVILLE is an author, activist, scholar, and comic writer. A leading influence in the New Weird movement, he has won numerous awards for his body of work which includes <I>Perdido Street Station</I>,<I> The Scar, The City & The City </I>and<I> Embassytown.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc8910f6